<script setup lang="ts"></script>

<template>
  <div class="loader">
    <div class="bar bar1" />
    <div class="bar bar2" />
    <div class="bar bar3" />
  </div>
</template>

<style scoped>
.loader {
  width: 45px;
  height: 45px;
  display: flex;
  align-items: flex-end;
  gap: 8px;
}

.bar {
  width: 12px;
  background: #2a598a;
  border-radius: 32px;
  animation: typing 1.2s infinite ease-in-out;
}

.bar1 {
  animation-delay: 0s;
}

.bar2 {
  animation-delay: 0.2s;
}

.bar3 {
  animation-delay: 0.4s;
}

@keyframes typing {
  0%,
  60%,
  100% {
    height: 15px;
  }
  30% {
    height: 35px;
  }
}
</style>
